import React from 'react';
import EdenredButtons from '@pages/DesignSystem/button/EdenredButton';
import ETypo from '@pages/DesignSystem/Typo';
import ImageComponent from '@sharedComponent/image-component';
import { images } from '@assets/img';
import './compliance-violations.scss';

const ComplianceSuccess = ({ onGoBack }) => {
	return (
		<div className="compliance-violations-container">
			<div className="compliance-header">
				<div className="header-content">
					<div className="title-section">
						<ETypo h2 bold className="page-title">
							Compliance Submission Successful
						</ETypo>
						<ETypo b1 className="page-subtitle">
							Your compliance data has been successfully submitted and is being processed.
						</ETypo>
					</div>
				</div>
			</div>

			<div className="compliance-content">
				<div className="success-content">
					<div className="success-icon">
						<div className="success-checkmark">
							<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle cx="32" cy="32" r="32" fill="#52c41a"/>
								<path d="m20 32 8 8 16-16" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</div>
					</div>
					
					<div className="success-message">
						<ETypo h3 medium className="success-title">
							Submission Complete!
						</ETypo>
					</div>

					<div className="success-actions">
						<EdenredButtons
							btnType="primary"
							onClick={onGoBack}
							leftIcon={<ImageComponent src={images.leftsarrow} />}
							className="back-to-employees-button">
							Go back
						</EdenredButtons>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ComplianceSuccess;